import { Box, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { InfoRow } from 'common/components/InfoRow';
import { getExpiryDisplay } from 'common/utils/expiryScale';
import { ICertificateWithScoringFragment } from 'graphql/types';

interface IProps {
    certificate: ICertificateWithScoringFragment;
}

export const CertificateInfo = ({ certificate }: IProps) => {
    const [translate] = useTranslation();

    return (
        <Stack spacing={2}>
            <InfoRow description={translate('certificateSelectPreview.name')}>
                {certificate.name}
            </InfoRow>

            {!!certificate.expiryScale && (
                <InfoRow
                    description={translate('certificateSelectPreview.validity')}
                >
                    {!!certificate.expiry
                        ? getExpiryDisplay(
                              certificate.expiry,
                              certificate.expiryScale
                          )
                        : translate('certificateSelectPreview.validityForever')}
                </InfoRow>
            )}

            {!!certificate.scoring.length && (
                <InfoRow
                    description={translate('certificateSelectPreview.score')}
                >
                    {certificate.scoring.map((score) => (
                        <Box key={score.scoringSystem.id} sx={{ mb: 1 }}>
                            {score.score}{' '}
                            {score.score === 1
                                ? score.scoringSystem.nameSingular
                                : score.scoringSystem.namePlural}
                        </Box>
                    ))}
                </InfoRow>
            )}
        </Stack>
    );
};
